module.exports = __webpack_public_path__ + "static/media/launchIcon.5bad4225.svg";